import _ from 'lodash';
import React, { Component } from 'react';
import FilaDepartamento from './FilaDepartamento';
import DepartamentoModal from './DepartamentoModal';

class DepartamentoListado extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      isLoaded: false,
      departamentos: [],
      originalHeight: 0,
    };
  }

  componentDidMount() {
    let desarrollo = this.props.desarrollo;
    let apiEndpoint = '/search/departamentos/' + desarrollo;
    const message = {
      desarrollo,
      frameHeight: window.innerHeight
    };

    fetch(apiEndpoint)
      .then(res => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            departamentos: result.desarrollo,
            originalHeight: window.innerHeight,
          });
          setTimeout(() => {
            // eslint-disable-next-line no-restricted-globals
            parent.postMessage(message, '*');
          }, 10);
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      );
  }

  showDepartamento = (deptId) => {
    const { desarrollo } = this.props;
    const { originalHeight } = this.state;

    this.refs.depModal.openModal(deptId, desarrollo, originalHeight);
  };

  render() {
    if (this.state.error) {
      return <div>Error: {this.state.error.message}</div>;
    } else if (!this.state.isLoaded) {
      return <div>Cargando...</div>;
    } else {
      let niveles = _.map(this.state.departamentos, (nivel) => {
        return (
          <tr key={ nivel.nivel }>
            <td>{ nivel.nivel }</td>
            {_.map(nivel.departamentos, (depto) => {
              return (
                <FilaDepartamento key={ depto.id } deptoId={ depto.id } onclick={ this.showDepartamento } numero={ depto.departamento } vendido={ depto.vendido } />
              );
            })}
          </tr>
        );
      });

      return (
        <div className="App">
          <table>
            <tbody>{ niveles }</tbody>
          </table>
          <DepartamentoModal ref="depModal" />
        </div>
      );
    }
  }
}

export default DepartamentoListado;



// WEBPACK FOOTER //
// ./react_src/Components/DepartamentoListado.js